import { Routes } from '@angular/router'

const loadMainAdminModule = () => import('./@shared/main-admin/main-admin.module').then(m => m.MainAdminModule)
const loadMerchantModule = () => import('./+merchant/merchant.module').then(m => m.MerchantModule)
const loadEventCheckinModule = () => import('./+governance-admin/+event/event-checkin/event-checkin.module').then(m => m.EventCheckinModule)

export const ROUTES: Routes = [
  {
    path: '',
    loadChildren: loadMerchantModule
  },
  {
    path: 'admin',
    loadChildren: loadMainAdminModule
  },
  // Public route for event check-in (no authentication required)
  {
    path: 'event-checkin/:customerCheckInCode',
    loadChildren: loadEventCheckinModule,
    data: {
      breadcrumb: 'Event Check-in',
    },
  }
]
